import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';

import {
    HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';

import { CoreService } from '../services/core.service';

@Injectable()
export class CoreInterceptor implements HttpInterceptor {
  api_url = environment.apiEndpoint;

  constructor(private coreService: CoreService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get the auth token from the service.
    const authToken = this.coreService.getAuthorizationToken();
    // console.log(`access_token: ${authToken}`);

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    var headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${authToken}`);
    headers = headers.set('Accept-Language', `en`);
    headers = headers.set('X-Platform', `admin`);
    const authReq = request
    .clone({
      headers: headers
    })
    .clone({
      setHeaders:
        request.url === this.api_url + 'passphrase'
          ? {
            'Req-UUID': uuidv4(),
            'Res-UUID': uuidv4()
          }
          : {}
    });;

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}

/** Provider for the Core Interceptor. */
export const coreInterceptorProvider: Provider =
  { provide: HTTP_INTERCEPTORS, useClass: CoreInterceptor, multi: true };
